import { HINT_COUNT } from '../constants/settings'
import { WORDS } from '../constants/wordlist'
import { VALID_GUESSES } from '../constants/validGuesses'
import { CharStatus, getGuessStatuses } from './statuses'
import Rand from 'rand-seed'

export const isWordInWordList = (word: string) => {
  return (
    WORDS.includes(word.toLowerCase()) ||
    VALID_GUESSES.includes(word.toLowerCase())
  )
}

export const isWinningWord = (word: string) => {
  return solution === word
}

// build a set of previously revealed letters - present and correct
// guess must use correct letters in that space and any other revealed letters
export const findFirstUnusedReveal = (word: string, guesses: string[]) => {
  const knownLetterSet = new Set<string>()
  for (const guess of guesses) {
    const statuses = getGuessStatuses(guess)

    for (let i = 0; i < guess.length; i++) {
      if (statuses[i] === 'correct' || statuses[i] === 'present') {
        knownLetterSet.add(guess[i])
      }
      if (statuses[i] === 'correct' && word[i] !== guess[i]) {
        return `Must use ${guess[i]} in position ${i + 1}`
      }
    }
  }

  for (const letter of Array.from(knownLetterSet.values())) {
    // fail fast, always return first failed letter if applicable
    if (!word.includes(letter)) {
      return `Guess must contain ${letter}`
    }
  }
  return false
}

export const getWordOfDay = () => {
  // January 1, 2022 Game Epoch
  const epochMs = new Date('January 1, 2022 00:00:00').valueOf()
  const now = Date.now()
  const msInDay = 86400000
  const index = Math.floor((now - epochMs) / msInDay)
  const nextday = (index + 1) * msInDay + epochMs
  const solution = WORDS[index % WORDS.length].toUpperCase()

  const splitSolution = solution.split('')
  const splitAlphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('')
  const hints: { [key: string]: CharStatus } = {}
  const r = new Rand(index.toString())
  for(let i = 0; i < HINT_COUNT; i++) {
    let hint = splitAlphabet[Math.floor(r.next() * splitAlphabet.length)]
    while(splitSolution.includes(hint) || hint in hints) {
      hint = splitAlphabet[Math.floor(r.next() * splitAlphabet.length)];
    }
    hints[hint] = 'absent'
  }
  return {
    solution: solution,
    hints: hints,
    solutionIndex: index,
    tomorrow: nextday,
  }
}

export const { solution, hints, solutionIndex, tomorrow } = getWordOfDay()
